import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';

import { AttendanceRoutingModule } from './attendance-routing.module';
import { AttendanceComponent } from './component/attendance/attendance.component';

import { OvertimeComponent } from './component/overtime/overtime.component';
import { AbsenceRequestComponent } from './component/absence-request/absence-request.component';
import { EmployeeDetailsComponent } from './component/employee-details/employee-details.component';
import { TableModule } from 'primeng/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TableexportModule } from '../admin/export-import/tableexport.module';
import { AttendanceGridComponent } from './component/attendance-grid/attendance-grid.component';
import { CalendarModule } from 'primeng/calendar';
import { FullCalendarModule } from '@fullcalendar/angular';
import { AttendanceRegularizationComponent } from './component/attendance-regularization/attendance-regularization.component';
import { TabViewModule } from 'primeng/tabview';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { SharedModule } from '../../../shared.module';
import { DecimalPipe } from '../../../pipes/decimal.pipe';
import { StepperModule } from 'primeng/stepper';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { AddAttendanceRegularizationComponent } from './component/attendance-regularization/add-attendance-regularization/add-attendance-regularization.component';
import { TnaAuthorisationComponent } from './component/tna-authorisation/tna-authorisation.component';
import { FieldMappingComponent } from './component/field-mapping/field-mapping.component';
import { AddFieldMappingComponent } from './component/field-mapping/add-field-mapping/add-field-mapping.component';
import { StagingAuditComponent } from './component/staging-audit/staging-audit.component';
import { TranslateModule } from '@ngx-translate/core';
import { SkeletonModule } from 'primeng/skeleton';

@NgModule({
  declarations: [
    AttendanceComponent,
    OvertimeComponent,
    AbsenceRequestComponent,
    EmployeeDetailsComponent,
    AttendanceGridComponent,
    AttendanceRegularizationComponent,
    AddAttendanceRegularizationComponent,
    TnaAuthorisationComponent,
    FieldMappingComponent,
    AddFieldMappingComponent,
    StagingAuditComponent,
  ],
  imports: [
    CommonModule,
    TableModule,
    FormsModule,
    ReactiveFormsModule,
    AttendanceRoutingModule,
    NgbModule,
    TableexportModule,
    CalendarModule,
    FullCalendarModule,
    TabViewModule,
    AvatarModule,
    BadgeModule,
    SharedModule,
    StepperModule,
    NgSelectModule,
    NgxMaterialTimepickerModule,
    TranslateModule,
    SkeletonModule,
  ],
  providers: [DecimalPipe, CurrencyPipe, DatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AttendanceModule {}
